// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"breadcrumb_breadcrumb__1kJVq","arrow":"breadcrumb_arrow__3jREX"};